import React from 'react';

export const scoreTone = (s) => (s == null ? '#3A4556' : s >= 80 ? '#00FF87' : s >= 60 ? '#00F0FF' : s >= 40 ? '#FFB800' : '#FF2E4D');
export const scoreLabel = (s) => (s == null ? 'Nessuna analisi' : s >= 80 ? 'Buono' : s >= 60 ? 'Discreto' : s >= 40 ? 'Da migliorare' : 'Critico');

const SEG = 36;
const pt = (cx, cy, r, a) => [cx + r * Math.cos(a), cy + r * Math.sin(a)];

export default function Gauge({ value, size = 180, label, testid }) {
  const c = size / 2;
  const r = c - 18;
  const v = value == null ? 0 : Math.max(0, Math.min(100, value));
  const lit = Math.round((v / 100) * SEG);
  const tone = scoreTone(value);
  const id = `g${testid}`;
  return (
    <div className="relative" style={{ width: size, height: size }} data-testid={testid}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <defs><filter id={id} x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="2.5" result="b" /><feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge></filter></defs>
        <g className="soc-spin"><circle cx={c} cy={c} r={c - 4} fill="none" stroke="rgba(0,240,255,0.25)" strokeWidth="1" strokeDasharray="2 7" /></g>
        <circle cx={c} cy={c} r={r - 16} fill="none" stroke="rgba(0,240,255,0.12)" strokeWidth="1" />
        {Array.from({ length: SEG }, (_, i) => {
          const a = Math.PI * 0.75 + (i / (SEG - 1)) * Math.PI * 1.5;
          const [x1, y1] = pt(c, c, r - 7, a);
          const [x2, y2] = pt(c, c, r + 5, a);
          const on = i < lit;
          return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke={on ? tone : 'rgba(138,153,173,0.18)'} strokeWidth="4" strokeLinecap="round" filter={on ? `url(#${id})` : undefined} style={{ transition: `stroke 300ms ${i * 18}ms` }} />;
        })}
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="soc-mono font-extrabold leading-none" style={{ color: tone, fontSize: size / 4.6, textShadow: `0 0 18px ${tone}88` }}>{value == null ? '--' : value}</span>
        <span className="soc-mono text-[10px] soc-muted mt-1">/ 100</span>
        <span className="soc-mono text-[10px] uppercase tracking-[0.2em] mt-1.5" style={{ color: tone }}>{label || scoreLabel(value)}</span>
      </div>
    </div>
  );
}
